<div class="radio-button-container" [ngClass]="{'space-right': option?.label}">
  <div class="radio-circle" [ngClass]="{'selected': option?.value == selectedValue}">
    <div class="radio-fill"></div>
  </div>
  <label class="radio-label">{{option?.label}}</label>
  <input class="radio-input" 
    [disabled]="disabled" 
    type="radio"
    [value]="option?.value"
    [name]="name"
    (change)="onInputChange()"
    (click)="OnSelect()"
  />
</div>